import { render } from "./TypeMaster.vue?vue&type=template&id=766001bd&scoped=true"
import script from "./TypeMaster.vue?vue&type=script&lang=js"
export * from "./TypeMaster.vue?vue&type=script&lang=js"

import "./TypeMaster.vue?vue&type=style&index=0&id=766001bd&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766001bd"]])

export default __exports__